import Vue from 'vue';

const state = {
};

const getters = {
    getEnum() {
        return state;
    }
};

const mutations = {
    setEnumValue(state, {key = '', array = []}) {
        Vue.set(state, key, array)
    }
};

const actions = {

};

export default {
    state,
    mutations,
    actions,
    getters
}


